// extracted by mini-css-extract-plugin
export default {"colabContainer":"viewClients_colabContainer__3waZQ","heading":"viewClients_heading__3Lx3w","box":"viewClients_box__vRDKY"};